export default {
  'all.table.customerName': '客户名称',
  'all.table.carbontreasures': '凡碳宝数',
  'all.table.numberShips': '船舶总数(只)',
  'all.table.numberShips1': '船舶数量',
  'all.table.shiptype': '船舶类型',
  'all.table.Contactperson': '联系人',
  'all.table.contactInformation': '联系方式',
  'all.table.Contactaddress': '联系地址',
  'all.table.totalcarbonemission': '总碳排',
  'all.table.Dateofregistration': '注册日期',
  'all.table.ExpirationDate': '到期日期',
  'all.table.NameOfShip': '船舶名称',
  'all.table.shipowner': '船东',
  'all.table.shipyard': '船厂',
  'all.table.FlagState': '船旗国',
  'all.table.NameofshipinEnglish': '船名(英)',
  'all.table.registerNo': '船检登记号',
  'all.table.IMONumber': 'IMO编号',
  'all.table.IMO': 'IMO',
  'all.table.PortOfDeparture': '出发港',
  'all.table.DepartureTime': '出发时间',
  'all.table.PortOfArrival': '到达港',
  'all.table.ArrivalTime': '到达时间',
  'all.table.SailingDistance': '航行距离(海里)',
  'all.table.SailingDistance1': '航行距离',
  'all.table.SailingTime': '航行时间(min)',
  'all.table.SailingTime1': '航行时间',
  'all.table.TotalHeavyOilConsumption': '重油总消耗(吨)',
  'all.table.deviceNo': '设备编号',
  'all.table.deviceStatus': '设备状态',
  'all.table.belong': '所属客户',
  'all.table.hardwareversion': '硬件版本',
  'all.table.Softwareversion': '软件版本',
  'all.table.activetime': '激活时间',
  'all.table.Validity': '有效期',

  'all.table.userName': '用户名',
  'all.table.nickName': '昵称',
  'all.table.gender': '性别',
  'all.table.phoneNumber': '手机号',
  'all.table.email': '邮箱',
  'all.table.creationTime': '创建时间',
  'all.table.creator': '创建人',
  'all.table.Operation': '操作',
  'all.table.Status': '状态',
  'all.table.Emissionreport': '排放报告',
  'all.table.Monitoringplan': '检测计划',
  'all.table.Storagetime': '入库时间',
  'all.table.shipclassification': '船级',
  'all.table.Totaltonnage': '总吨',
  'all.table.Deadweighttonnage': '载重吨',
  'all.table.Nettonnage': '净吨',
  'all.table.TEU': '箱位数(TEU)',
  'all.table.Cargounitcapacity': '货物单元容量',
  'all.table.Cargounitcapacity1': '每货物单元容量',
  'all.table.DWT': '结构加强前的设计与参考DWT',
  'all.table.Designaccommodate': '设计载客',
  'all.table.storageCapacity': '仓容(m³)',
  'all.table.Lengthbetweenwaterlines': '水线间长(m)',
  'all.table.Designdraft': '设计吃水(m)',
  'all.table.Shipwidth': '船宽(m)',
  'all.table.MCR': '主机额定装机功率(MCR)(kw)',
  'all.table.auxiliaryEnginePowers': '辅机额定功率(kw)',
  'all.table.SFC': 'EEXI技术案卷中的辅机SFC(g/kWh)',
  'all.table.auxiliaryEngineMode': '辅机工作模式',
  'all.table.2-stroke': '二冲程',
  'all.table.4-stroke': '四冲程',
  'all.table.iceClass': '冰级',
  'all.table.PPTOi': '轴带发电机功率(PPTOi)(kw)',
  'all.table.eediEvi': 'EEDI或EVI',
  'all.table.eediEviContext': 'EEDI或EVI描述',
  'all.table.ManagementDate': '经营管理日期',
  'all.table.ManagementDates': '经营管理开始日期',
  'all.table.ManagementDatee': '经营管理结束日期',
  'all.table.shipPic': '船图片',
  'all.table.monitorPlanStatus': '监测计划状态',
  'all.table.monitorPlanFile': '监测计划文件',
  'all.table.dischargeReportStatus': '排放报告状态',
  'all.table.dischargeReportFile': '排放报告文件',
  'all.table.principal': '负责人',
  'all.table.shipmessage': '船舶信息',


  'all.table.Speed': '服务航速',
  'all.table.completionDate': '建造完工日期',
  'all.table.Voyagedate': '航行日期',
  'all.table.voyagerecords': '航行记录',
  'all.table.Voyagetime': '航行时间',
  

  'all.modal.newUser': '新增用户',

  'all.table.role': '角色',
  'all.table.Rights': '权限',
  'all.table.noiPermission': '暂未分配权限',

  'all.table.index': '序号',
  'all.table.Fueltype': '燃料种类',
  'all.table.unit': '单位',
  'all.table.Oils': '油品',
  'all.table.oilconsumption': '油耗',

  'all.table.associatedship': '关联船舶',
  'all.table.loginUserName': '登录用户名',
  'all.table.uploadtime': '上传时间',
  'all.table.annual': '年度',
  'all.table.annual1': '评估年度',
  'all.table.ClassificationSocietyDocuments': '船级社文件',
  'all.table.ClassificationSociety': '船级社',
  'all.table.ShipRegistration': '船籍',
  'all.table.protocolFile': '授权协议文件',
  'all.table.Loadingcapacity': '装载量(吨)',
  'all.table.Totalconsumption': '重油总消耗(吨)',
  'all.table.Parkingtime': '停泊时间',
  'all.table.Consumptionofvarioustypesofheavyoil': '重油各类型消耗',
  'all.table.voyagemessage': '航行信息',
  'all.table.Ancillarydocuments': '附属文件',
  'all.table.Cargocapacity': '载货量',
  'all.table.Statisticalcycle': '统计周期',
  'all.table.voyageRecordCount': '上传次数',
  'all.table.calculation': '计算',
  'all.table.Improvementmeasures': '改进措施',
  'all.table.Energysavingtechnology': '节能技术',
  'all.table.Percentageofenergysaving': '节能百分比',
  'all.table.company': '船舶公司',
  'all.table.Calculaterating': '计算评级',
  'all.table.BasicSettings': '基本设置',
  'all.table.Username': '用户名',
  'all.table.AccountnumberID': '账号ID',
  'all.table.avatar': '头像',
  'all.table.changeavatar': '更换头像',
  'all.table.Updatebasicinformation': '更新基本信息',
  'all.table.corporatename': '公司名称',
  'all.table.titleforSys': '能效管理系统',
  'all.table.titleforSys1': '2次密码不相同',
  'all.table.titleforSys2': '2次密码必须相同',
  'all.table.titleforSys3': '修改密码成功',
  'all.table.titleforSys4': '修改密码',
  'all.table.titleforSys5': '新密码',
  'all.table.titleforSys6': '确认密码',
  'all.table.titleforSys7': '请确认新密码',
};